import fieldDataClient from "../../api/digitalTwin/fieldDataClient";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFieldImageDetailFailure,
  fetchFieldImageDetailStart,
  fetchFieldImageDetailSuccess,
  fetchFieldImagesFailure,
  fetchFieldImagesStart,
  fetchFieldImagesSuccess,
} from "../../store/features/digitalTwin/fieldImagesSlice";

const IMAGES_URL = "/images/";
const IMAGE_URL = "/image";

const getFieldImageDetail = async (image_id) => {
  const response = await fieldDataClient.get(`${IMAGE_URL}/${image_id}`);

  return response.data?.image || response.data;
};

const getLatestFieldImages = async (field_id) => {
  const response = await fieldDataClient.get(IMAGES_URL, {
    params: {
      field_id,
      order_by: "timestamp",
      order_dir: "desc",
      limit: 100,
    },
  });

  // The list response already contains the coordinates required by map markers.
  // Fetching every image detail here downloads up to 100 base64 payloads and
  // prevents markers from rendering until all requests have completed.
  return response.data;
};

function* fetchFieldImagesSaga(action) {
  try {
    const { field_id } = action.payload;

    if (!field_id) {
      yield put(fetchFieldImagesSuccess({
        data: [],
        count: 0,
        total: 0,
        limit: 100,
        offset: 0,
      }));
      return;
    }

    const imagesData = yield call(getLatestFieldImages, field_id);
    yield put(fetchFieldImagesSuccess(imagesData));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(fetchFieldImagesFailure(errorMessage));
  }
}

function* fetchFieldImageDetailSaga(action) {
  try {
    const { image_id } = action.payload;

    if (!image_id) {
      yield put(fetchFieldImageDetailSuccess(null));
      return;
    }

    const imageData = yield call(getFieldImageDetail, image_id);
    yield put(fetchFieldImageDetailSuccess(imageData));
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(fetchFieldImageDetailFailure(errorMessage));
  }
}

export default function* fieldImagesSaga() {
  yield takeLatest(fetchFieldImagesStart.type, fetchFieldImagesSaga);
  yield takeLatest(fetchFieldImageDetailStart.type, fetchFieldImageDetailSaga);
}
